import { useLocation } from "react-router-dom";

export const useUrlSearchParam = (paramName: string): string | null => {
   const { search } = useLocation();
   const urlParams = new URLSearchParams(search);

   return urlParams.get(paramName);
};
